<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de envio">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/integracao/bnafar/relatorio-envio/List'

export default {
    components: {List},
}
</script>